import React, {useEffect} from 'react'
import './SurveyLoader.css'
import {useAppSelector} from "@/shared/lib/hooks/useAppSelector"; // импортируем стили (ниже будет CSS)

interface SurveyLoaderProps {
    progress: number
}

export const SurveyLoader: React.FC<SurveyLoaderProps> = ({ progress }) => {
    const degree = (progress / 100) * 360
    const riskResult = useAppSelector(state => state.questionnaire.riskResult);

    useEffect(() => {
        if (riskResult) {
            console.log('%c📦 RiskResult в Redux изменился:', 'color: blue; font-weight: bold;', riskResult);
        }
    }, [riskResult]);
    return (
        <main className="layout__content">
        <section className="section layout__section test response-checks-form" style={{ display: 'block' }}>
            <div className="container">
                <div className="section__content">
                    <div className="test__finisn test-finish" style={{ textAlign: 'center' }}>
                        <h5 className="title test-finish__title" style={{ fontSize: '22px', fontWeight: 600 }}>Анализируем ответы</h5>
                        <div className="test-finish__description" style={{ margin: '8px auto 24px', color: '#666' }}>
                            Подождите, подготовка программы выполняется. Это занимает примерно 1–2 минуты.
                        </div>

                        <div className="loader-circle-wrapper">
                            <div className="loader-circle">
                                <div
                                    className="loader-circle__progress"
                                    style={{
                                        background: `conic-gradient(#E2EF4A ${degree}deg, #fff ${degree}deg)`,
                                    }}
                                />
                                <div className="loader-circle__text">{progress}%</div>
                            </div>
                        </div>

                        <div className="test-finish__description" style={{ marginTop: 32 }}>
                            Немного времени, скоро ваша программа будет готова.
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </main>
    )
}
